import List from "./List";
import Create from "./Create";
import Show from "./Show";
import Edit from "./Edit";

export const MarketingBannerList = List;
export const MarketingBannerCreate = Create;
export const MarketingBannerShow = Show;
export const MarketingBannerEdit = Edit;
